import React from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Loading } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { fetchEnvironmentVariables } from "../../api/adminService";
export var AdminEnvironmentVariables = function () {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useQuery(["environment-variables"], function () { return fetchEnvironmentVariables(ky); }), environmentVariablesResponse = _a.data, isLoading = _a.isLoading, error = _a.error;
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    if (error || !environmentVariablesResponse) {
        return (React.createElement("div", null,
            formatMessage({ id: "ui-br-agency.modal.label.error" }),
            ":",
            " ",
            formatMessage({
                id: "ui-br-agency.admin.environment.variables.error",
            })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.description" }),
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.title.environment.variables", tagName: "h1" }),
        React.createElement("ul", null, environmentVariablesResponse.environmentVariables.map(function (environmentVariable) { return (React.createElement("li", { key: environmentVariable.name },
            React.createElement("strong", null,
                environmentVariable.name,
                ":"),
            " ",
            environmentVariable.value)); }))));
};
